import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import {
  getOrganizationSchemaAdditionalFields,
  organizationSchema,
} from "./organization";
import { getPersonSchemaAdditionalFields, personSchema } from "./person";

export const tenantSchema = z.union([
  z.object({
    person: personSchema,
  }),
  z.object({
    organization: organizationSchema,
  }),
]);

export type Tenant = z.infer<typeof tenantSchema>;

export function getTenantSchemaAdditionalFields(additionalFields: {
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof tenantSchema {
  return z.union([
    z.object({
      person: getPersonSchemaAdditionalFields(additionalFields),
    }),
    z.object({
      organization: getOrganizationSchemaAdditionalFields(additionalFields),
    }),
  ]);
}
